


export const summary_table_data = [
  { label: "MID", value: "8032538236" },
  { label: "Merchant Name", value: "800-397-0806Relaxium2day" },
  { label: "Case ID", value: "1056151019" },
  { label: "Transaction ID", value: "10176861244" },
  { label: "ARN/REF", value: "55436874335283354836771" },
  { label: "Chargeback Date", value: "Jan 24, 2025" },
  { label: "Chargeback Amount", value: "$320.75" },
  { label: "BIN", value: "514887" },
  { label: "Last Four", value: "0859" },
  { label: "Transaction Date", value: "Dec 1, 2024" },
  { label: "Transaction Amount", value: "$320.75" },
]